module.exports = __webpack_public_path__ + "img/png_wgzl_1@2x.c18af80d.png";